import React from 'react';
import { IMaskInput } from 'react-imask';
import { getDocumentMasks } from '../utils/documentMask';

const DocumentInputMasked = React.forwardRef(function DocumentInputMasked(props, ref) {
    const { onChange, name, documentType = 'auto', ...other } = props;

    return (
        <IMaskInput
            {...other}
            inputRef={ref}
            mask={getDocumentMasks(documentType)}
            prepareChar={str => (/[a-z]/.test(str) ? str.toUpperCase() : str)}
            value={props.value?.toString() || ''}
            unmask
            onAccept={newValue => {
                onChange({
                    target: {
                        name,
                        value: newValue,
                    },
                });
            }}
        />
    );
});

export default DocumentInputMasked;
